module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/012-1a480a0c6428e37e96e4f3eecf6dab57.jpg";